import React, { useState, useEffect } from 'react';
import './HomeHero.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function HomeHero() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/sliders/public`);
        const data = await res.json();
        // Transform data to match component structure if needed
        const formattedSlides = data.map(s => ({
          type: s.type,
          src: `${API_BASE_URL}${s.src}`,
          heading: s.heading,
          subText: s.subText
        }));
        setSlides(formattedSlides);
      } catch (error) {
        console.error("Failed to load slides", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSlides();
  }, []);

  const length = slides.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (loading) return null; // Or a loading spinner
  if (!Array.isArray(slides) || slides.length <= 0) return null;

  return (
    <section className="home-hero-layout-section">
      
      {/* --- Slider Backgrounds --- */}
      {slides.map((slide, index) => {
        return (
          <div
            className={index === current ? 'home-hero-slide active' : 'home-hero-slide'}
            key={index}
          >
            {index === current && (
              <>
                {slide.type === 'video' ? (
                  <video 
                    className="home-hero-layout-media" 
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                  >
                    <source src={slide.src} type="video/mp4" />
                  </video>
                ) : (
                  <img 
                    src={slide.src} 
                    alt="Hero Slide" 
                    className="home-hero-layout-media" 
                  />
                )}
              </>
            )}
          </div>
        );
      })}

      {/* --- Navigation Arrows --- */}
      {length > 1 && (
        <>
          <button className="home-hero-arrow left-arrow" onClick={prevSlide}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>
          <button className="home-hero-arrow right-arrow" onClick={nextSlide}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>
        </>
      )}

      {/* --- Content Wrapper (ONLY IF TEXT EXISTS) --- */}
        {(slides[current].heading || slides[current].subText) && (
          <div className="home-hero-layout-content-wrapper">
            <div className="home-hero-layout-text-container">
              {slides[current].heading && (
                <h1 className="home-hero-layout-title">
                  {slides[current].heading}
                </h1>
              )}
              {slides[current].subText && (
                <p className="home-hero-layout-subtitle">
                  {slides[current].subText}
                </p>
              )}
            </div>
          </div>
        )}

      
    </section>
  );
}

export default HomeHero;